"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _colorCircle = require("./color-circle.styled");

var _lazyLoadImage = require("../lazy-load-image");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorCircle = function ColorCircle(_ref) {
  var _ref$hexValue = _ref.hexValue,
      hexValue = _ref$hexValue === void 0 ? null : _ref$hexValue,
      _ref$fileReference = _ref.fileReference,
      fileReference = _ref$fileReference === void 0 ? null : _ref$fileReference,
      _ref$altText = _ref.altText,
      altText = _ref$altText === void 0 ? null : _ref$altText,
      _ref$skipLazy = _ref.skipLazy,
      skipLazy = _ref$skipLazy === void 0 ? false : _ref$skipLazy;
  return /*#__PURE__*/_react.default.createElement(_colorCircle.ColorCircleStyled, {
    hexValue: !fileReference && hexValue
  }, fileReference && /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: fileReference,
    alt: altText,
    skipLazy: skipLazy
  }));
};

var _default = ColorCircle;
exports.default = _default;